import { render, staticRenderFns } from "./VehicleImage.vue?vue&type=template&id=52d14934"
import script from "./VehicleImage.vue?vue&type=script&lang=js"
export * from "./VehicleImage.vue?vue&type=script&lang=js"
import style0 from "./VehicleImage.vue?vue&type=style&index=0&id=52d14934&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports